import * as Sentry from '@sentry/nuxt';

Sentry.init({
  dsn: useRuntimeConfig().public.sentry.dsn,
  tracesSampleRate: 1.0,
  integrations: [Sentry.browserProfilingIntegration()],
  environment: useRuntimeConfig().public.sentry.environment,
});
